export default {"src":"/_next/static/media/zec.f69e7cfc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};